<template>

  <el-container style="margin-top: 30px;margin-left: 50px;width: 100%;">
    <div style="width: 80%;">
      <el-row :span="2">
      	<el-col :span="3"><el-input v-model="name" style="width: 150px;" placeholder="请输入关键词"></el-input></el-col>
        <el-col :span="2"><el-button type="success" round @click="add()">确定</el-button></el-col>
        <el-col :span="2"><el-button type="info" round @click="del()">清空</el-button></el-col>
      </el-row>
      <el-row :span="2" style="margin-top: 50px;text-align: center;">
        <el-col :span="6" style="border-radius: 0px;border:1px solid #ccc;height: 800px;">
          <h2>拆分</h2>
          <el-button  class="button-new-tag" size="small" @click="paixu">重新排序</el-button>
          <el-row v-for="(name,index) in datac" style="margin-top: 10px;">

            <el-col :span="4" style="margin-left: 20%;margin-top: 10px;">{{name.name}}</el-col>
            <el-col :span="4" @click.native="handleClosec(name.num)" style="margin-top: 10px;">删除</el-col>
            <el-col :span="4"><el-input v-model="name.num" style="width: 50px;"></el-input></el-col>
          </el-row>
          <!-- <el-row>
            <el-tag
              v-for="tag in datac"
              :key="tag"
              type="warning"
              closable
              @close="handleClosec(tag)"
              style="width: 60%;margin-top: 10px;">
              {{tag}}
            </el-tag>
          </el-row> -->
          <el-row style="margin-top: 10px;" v-if="datac.length > 0">
            <el-input
              class="input-new-tag"
              v-if="inputVisiblec"
              v-model="inputValuec"
              ref="saveTagInputc"
              size="small"
              @keyup.enter.native="handleInputConfirmc"
              @blur="handleInputConfirmc"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputc">添加拆分</el-button>
          </el-row>
        </el-col>
        <el-col :span="6" style="border-radius: 0px;border:1px solid #ccc;height: 800px;overflow-x:scroll;">
          <h2>组合</h2>
          <el-row>
            <el-tag
              v-for="tag in dataz"
              :key="tag"
              type="success"
              closable
              @close="handleClosez(tag)"
              style="width: 60%;margin-top: 10px;">
              {{tag}}

            </el-tag>

          </el-row>
          <el-row style="margin-top: 10px;" v-if="datac.length > 0">
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">添加组合</el-button>
          </el-row>
        </el-col>
        <el-col :span="6" style="border-radius: 0px;border:1px solid #ccc;height: 800px;overflow-x:scroll;">
          <h2>拆分+组合</h2>
          <el-row v-for="(name,index) in data" style="margin-top: 10px;">
            {{name}}

          </el-row>
        </el-col>
      </el-row>
    </div>

  </el-container>
</template>

<script>
  export default {
    data() {
       return {
        name:'',
        data:[],
        datac:[],
        dataz:[],
        inputVisible: false,
        inputValue: '',
        inputVisiblec: false,
        inputValuec: ''

      }
    },
  directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }

    },

  methods:{
    sortKey(array,key){
      return array.sort(function(a,b){
        var x = a[key];
        var y = b[key];
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    paixu(){
      this.datac = this.sortKey(this.datac,'num')
      this.data = []
      this.dataz = []
      var a = 1
      this.datac.forEach((j,index) => {
        var b = 0
        this.datac.forEach((k,index) => {
          b = b+1
          if(b>a){
            this.dataz.push(j['name']+k['name'])
          }

        })
        a = a+1
      })
      var x = 1
      this.datac.forEach((j,index) => {
        var y = 0
        this.datac.forEach((k,index) => {
          y = y+1
          if(y>x){
            var z = 0
            this.datac.forEach((l,index) => {
              z = z+1
              if(z > y){
                this.dataz.push(j['name']+k['name']+l['name'])
              }

            })

          }

        })
        x = x+1
      })
      this.datac.forEach((element,index) => {
        this.data.push(element.name)
      })
      this.dataz.forEach((element,index) => {
        this.data.push(element)
      })
    },
    del(){
      this.name = ''
      this.data = []
      this.datac = []
      this.dataz = []
    },
    showInput() {
      this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dataz.push(inputValue);
        this.data = []
        this.datac.forEach((element,index) => {
          this.data.push(element.name)
        })
        this.dataz.forEach((element,index) => {
          this.data.push(element)
        })
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    showInputc() {
      this.inputVisiblec = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInputc.$refs.input.focus();
        });
    },
    handleInputConfirmc() {
      let inputValuec = this.inputValuec;
      if (inputValuec) {
        this.datac.push({'name':inputValuec,'num':this.datac.length+1});
        this.data = []
        this.dataz = []
        var a = 1

        this.datac.forEach((j,index) => {
          var b = 0
          this.datac.forEach((k,index) => {
            b = b+1
            if(b>a){
              this.dataz.push(j['name']+k['name'])
            }

          })
          a = a+1
        })
        var x = 1
        this.datac.forEach((j,index) => {
          var y = 0
          this.datac.forEach((k,index) => {
            y = y+1
            if(y>x){
              var z = 0
              this.datac.forEach((l,index) => {
                z = z+1
                if(z > y){
                  this.dataz.push(j['name']+k['name']+l['name'])
                }

              })

            }

          })
          x = x+1
        })
        this.datac.forEach((element,index) => {
          this.data.push(element.name)
        })
        this.dataz.forEach((element,index) => {
          this.data.push(element)
        })
      }
      this.inputVisiblec = false;
      this.inputValuec = '';
    },
    handleClosec(index) {
      this.datac.splice(index-1, 1);
      //111111111111111111111111111111111111
      this.datac.forEach((k,indexs) => {

        this.datac[indexs]['num'] = indexs+1
      })
      this.data = []
      this.dataz = []
      var a = 1
      this.datac.forEach((j,index) => {
        var b = 0
        this.datac.forEach((k,index) => {
          b = b+1
          if(b>a){

            this.dataz.push(j['name']+k['name'])
          }

        })
        a = a+1
      })
      var x = 1
      this.datac.forEach((j,index) => {
        var y = 0
        this.datac.forEach((k,index) => {
          y = y+1
          if(y>x){
            var z = 0
            this.datac.forEach((l,index) => {
              z = z+1
              if(z > y){
                this.dataz.push(j['name']+k['name']+l['name'])
              }
      
            })
      
          }
      
        })
        x = x+1
      })
      this.datac.forEach((element,index) => {
        this.data.push(element.name)
      })
      this.dataz.forEach((element,index) => {
        this.data.push(element)
      })

    },
    handleClosez(tag) {
      this.dataz.splice(this.dataz.indexOf(tag), 1);
      this.data = []
      this.datac.forEach((element,index) => {
        this.data.push(element.name)
      })
      this.dataz.forEach((element,index) => {
        this.data.push(element)
      })
    },
    add(){
      if(this.name == ''){
        this.msg('请输入关键词','error')
        return false;
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/jiebaYuyan',
      	params:{
      		name:this.name,

      	}
      })
      .then(res=>{
        res.data.data['datac'].forEach((element,index) => {
          this.datac.push({'name':element,'num':index+1})
        })
        this.data = res.data.data['data']
        // this.datac = res.data.data['datac']
        this.dataz = res.data.data['dataz']

      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/cjieba.vue